import { MenuItem, ListItemText, styled } from '@mui/material';
import { useStyleHelpers } from '../hooks';

export const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) =>
    prop !== 'isMultiple' &&
    prop !== 'stylingVariant' &&
    prop !== 'isWideDropdown' &&
    prop !== 'displayHomeIcon' &&
    prop !== 'isInFocus',
})(({ theme, checked, disabled, stylingVariant, isMultiple, isWideDropdown, displayHomeIcon, isInFocus }) => {
  const { selectItemFontStyles } = useStyleHelpers({ stylingVariant, theme });
  let itemMaxWidth = '158px';
  const fontFamily = displayHomeIcon ? 'Roboto-Bold' : selectItemFontStyles().fontFamily;

  if (isWideDropdown) {
    itemMaxWidth = '266px';
  } else if (isMultiple) {
    itemMaxWidth = '130px';
  }

  return {
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    height: theme.spacing(5.25),
    width: '100%!important',
    borderRadius: '6px',
    backgroundColor: (checked && !disabled) || isInFocus ? theme.palette.background?.selected : 'transparent',
    border: isInFocus ? `1px dashed ${theme.palette.background?.blue_hover}` : 'transparent',
    '&:hover': {
      backgroundColor:
        checked && !disabled
          ? `${theme.palette.background?.pages_background} !important`
          : `${theme.palette.background?.selected} !important`,
    },
    '& .MuiTypography-root': {
      fontSize: selectItemFontStyles().fontSize,
      color: displayHomeIcon ? theme.palette.text.txt_default : 'inherit',
      maxWidth: itemMaxWidth,
      letterSpacing: '0.035em',
      fontFamily,
      overflow: 'hidden',
    },
    '& .MuiListItemText-root': {
      flex: 0,
      minWidth: 'auto',
      height: theme.spacing(3),
      alignItems: 'center',
      display: 'flex',
    },
  };
});

export const StyledListItemText = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'stylingVariant',
})(({ theme, stylingVariant, color, style: customStyle }) => {
  const { selectItemColor, selectItemBorderRadius, selectItemBgColor, selectItemPadding } = useStyleHelpers({
    theme,
    stylingVariant,
    color,
  });

  const style =
    customStyle !== null && customStyle !== undefined
      ? { ...customStyle }
      : { color: selectItemColor(), backgroundColor: selectItemBgColor() };
  return {
    padding: selectItemPadding(),
    borderRadius: selectItemBorderRadius(),
    ...style,
  };
});
